import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateOrder from "./OrderUpdate";
import OrderViews from "./OrderView";
import html2pdf from 'html2pdf.js';
import ReactDOM from 'react-dom';
import DeletedOrder from "./DeleteOrder";
import vAdminformat from '../../adminFormat';
import CustomDateRangePicker from "../CustomDateRangePicker";

/*import DeletedCustomer from "./DeleteOrders";  */


const server_backend = config.API_URL;

const OrdersHistory = ({ email }) => {
    const [OrderList, setOrderList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBOrder, setViewBOrder] = useState(false);
    const [currentOrder, setCurrentOrder] = useState(0);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });

    const [statusQuot, setStatusQuot] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        const getOrders = async () => {
            try {
                const response = await axios.get(`${server_backend}/Orders/list`, headers);
                //console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    setOrderList(data.filter((element) => element.est_ID === 11));
                }
            } catch (error) {
                console.log(error)
            }
        }
        getOrders();
    }, []);


    const getOrders = async () => {

        try {
            const response = await axios.get(`${server_backend}/Orders/list`, headers);

            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                setOrderList(data.filter((element) => element.est_ID === 11));
            }
        } catch (error) {
            console.log(error)
        }
    }

    //with the aim of automatically refreshing the quote
    /*  setTimeout(() => {
         getOrders()
     }, 5000);
  */

    useEffect(() => {
        const getStatusOrder = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Order`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusOrder();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/Orders/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setOrderList(response.data.RES_RESULT);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewOrder = () => {
        setViewBOrder(true);
    }

    const CloseViewOrder = () => {
        setViewBOrder(false);
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const downloadInvoice = (Order) => {

        return new Promise((resolve, reject) => {
            const tempDiv = document.createElement('div');
            document.body.appendChild(tempDiv);

            //Render the component and pass a callback that will be executed when ready
            ReactDOM.render(
                <OrderViews
                    OrderID={Order.ord_ID}
                    onRenderComplete={() => {
                        //HTML2PDF configuration
                        const options = {
                            margin: 0,
                            filename: `invoice_${Order.name}.pdf`,
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: { scale: 2 },
                            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                        };

                        //generate and download the PDF
                        const element = document.getElementById('invoice-container');

                        html2pdf().set(options).from(element).save().then(() => {
                            //Clean the dom stirring the temporal element
                            ReactDOM.unmountComponentAtNode(tempDiv);
                            document.body.removeChild(tempDiv);
                            resolve();
                        }).catch(error => {
                            reject(error);
                            console.error('Error generating PDF:', error);
                            ReactDOM.unmountComponentAtNode(tempDiv);
                            document.body.removeChild(tempDiv);
                        });
                    }}
                />,
                tempDiv
            );
        });
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = OrderList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(OrderList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {viewBOrder ? (
                /*  <ViewCustomer email={email} customerID={currentCustomer} CloseViewCustomer={CloseViewCustomer} /> */
                <OrderViews OrderID={currentOrder} getOrders={getOrders} CloseViewOrder={CloseViewOrder} />
            ) : (
                isUpdating ? (
                    <UpdateOrder onClose={CloseModalUpdate} onOrderID={currentOrder} getOrders={getOrders} />
                ) : (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">History</h4>
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Orders</a></li>
                                            <li className="breadcrumb-item active">List</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card" id="tasksList">
                                    <div className="card-header border-0">
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">All Orders </h5>
                                            <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                    <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                </button>
                                            </div>
                                           {/* <div className="flex-shrink-0">
                                                <Link className="btn btn-success add-btn" to="/create-Order">
                                                    <i className="ri-add-line align-bottom me-1"></i> Generate Order
                                                </Link>
                                            </div> */}
                                        </div>
                                    </div>
                                    {filtersEnabled && (
                                        <div className="card-body border border-dashed border-end-0 border-start-0">
                                            <div className="row g-3">
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            disabled={!filtersEnabled}
                                                            value={filterBy}
                                                            onChange={handleFilterByChange}
                                                        >
                                                            <option value="">Filter by</option>
                                                            <option value="ord_ID">ID</option>
                                                            <option value="fullname">Customer name</option>
                                                            <option value="email">Email</option>
                                                            <option value="phone">Phone</option>
                                                            <option value="city">City</option>
                                                        </select>

                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            id="idFilterStatus"
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterStatusChange}
                                                        >
                                                            <option value={0}>Filter status</option>
                                                            {statusQuot.map((status) => (
                                                                <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <CustomDateRangePicker onDateChange={handleDateChange} />
                                                </div>
                                                <div className="col-12">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="Search for tasks or something..."
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterValueChange}
                                                        />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    )}

                                    <div className="card-body">
                                        <div
                                            className="table-responsive table-card mb-4"
                                            style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                        >
                                            <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                <thead className="table-light text-muted">
                                                    <tr>
                                                        <th className="th-hover" onClick={() => handleColumnClick("ord_ID")}>ID</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("fullname")}>Full name</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("phone")}>Phone</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("date_created")}>Dated created</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("city")}>User Created</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("status")}> Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list form-check-all">
                                                    {currentItems.map((Orders_L) => (
                                                        <tr key={Orders_L.ord_ID}>
                                                            <td className="id">
                                                                <Link to="#" className="fw-medium link-primary">
                                                                    {Orders_L.ord_ID}
                                                                </Link>
                                                            </td>
                                                            <td className="fullname">{Orders_L.fullname}</td>
                                                            <td className="phone">{Orders_L.phone}</td>

                                                            <td className="date">{vAdminformat.FormatDate(Orders_L.date_created)}</td>
                                                            <td className="user_created">{Orders_L.user_created}</td>
                                                            <td className="status">
                                                                <span className={`${Orders_L.est_ID === 7 ? "badge badge-soft-warning text-uppercase"
                                                                    : (
                                                                        Orders_L.est_ID === 8 ? "badge badge-soft-success text-uppercase"
                                                                            : (
                                                                                Orders_L.est_ID === 9 ? "badge badge-soft-secondary text-uppercase" : (
                                                                                    Orders_L.est_ID === 10 ? "badge badge-soft-success text-uppercase" : (
                                                                                        Orders_L.est_ID === 11 ? "badge badge-soft-danger text-uppercase" : (
                                                                                            Orders_L.est_ID === 12 ? "badge badge-label bg-danger" : null
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                    )} text-uppercase`}>
                                                                    {Orders_L.status_name}
                                                                </span>
                                                            </td>
                                                            <td className="due_date">
                                                                <ul className="list-inline hstack gap-2 mb-0 fs-5">
                                                                    <li className="list-inline-item" >
                                                                        <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                            setCurrentOrder(Orders_L.ord_ID);
                                                                            showViewOrder()
                                                                        }}
                                                                            data-toggle="tooltip"
                                                                            data-placement="top" title="View ">
                                                                            <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                        </Link>
                                                                    </li>

                                                                   
                                                                  {/*  <li className="list-inline-item edit">
                                                                        <Link
                                                                            type="button"
                                                                            onClick={() => {
                                                                                ShowModalUpdate();
setCurrentOrder(Orders_L.ord_ID);
                                                                            }}
                                                                            className="text-primary d-inline-block edit-item-btn"
                                                                            data-toggle="tooltip"
data-placement="top" title="Update " >
                                                                            <i className="ri-pencil-fill fs-16"></i>
                                                                        </Link>
                                                                    </li>



                                                                    <li className="list-inline-item" >
<Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                            DeletedOrder(Orders_L.ord_ID, getOrders)
                                                                        }} data-toggle="tooltip"
                                                                            data-placement="top" title="Delete">
<i className="ri-delete-bin-5-fill fs-16"></i>
                                                                        </Link>
                                                                    </li> */}
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row justify-content-between align-items-center">
                                            <div className="col-auto me-3">
                                                <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, OrderList.length)} of {OrderList.length} entries</p>
                                            </div>
                                            <div className="col-auto">
                                                <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                    </li>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row g-0 text-center text-sm-start">
                                            <div className="col-sm-6">
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default OrdersHistory;
